import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { BusinessCenter } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import LoginPage from '../../pages/LoginPage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(180deg, #FAFAF7 0%, #F1F2DA 100%)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 80,
            height: 80,
            borderRadius: '50%',
            bgcolor: 'primary.main',
            mb: 3,
          }}
        >
          <BusinessCenter sx={{ fontSize: 40, color: 'white' }} />
        </Box>
        <CircularProgress size={40} sx={{ mb: 2 }} />
        <Typography variant="h6" color="text.secondary">
          Loading Bundle Tool...
        </Typography>
      </Box>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;